import * as ReactGA from 'react-ga';
import { History } from 'history';

const gaId = process.env.REACT_APP_GA_KEY || "";

export const initializeGA = () => {
    ReactGA.initialize(gaId, {
        debug: process.env.NODE_ENV === "development",
        gaOptions: { cookieDomain: 'auto' }
    });
    
    ReactGA.set({ page: "/" });
    ReactGA.pageview("/");
}

export const trackPages = (history: History) => {
    history.listen((location, action) => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    });
}

const EMAIL_CATEGORY = 'Email';
const UNREG_MSG_ACTION = 'Message sent to unregistered address';
const REPORTER_MSG_ACTION = 'Message sent to reporter';
const UNIT_LABEL = 'Unit';
const TRUCK_LABEL = 'Truck'

export const sendUnitInformationEmailEvent = () => {
    ReactGA.event({
        category: EMAIL_CATEGORY,
        action: UNREG_MSG_ACTION,
        label: UNIT_LABEL
    });
}

export const sendUnitInformationToReporterEmailEvent = () => {
    ReactGA.event({
        category: EMAIL_CATEGORY,
        action: REPORTER_MSG_ACTION,
        label: UNIT_LABEL
    });
}

export const sendTruckInformationEmailEvent = () => {
    ReactGA.event({
        category: EMAIL_CATEGORY,
        action: UNREG_MSG_ACTION,
        label: TRUCK_LABEL
    });
}

export const sendTruckInformationToReporterEmailEvent = () => {
    ReactGA.event({
        category: EMAIL_CATEGORY,
        action: REPORTER_MSG_ACTION,
        label: TRUCK_LABEL
    });
}



// WEBPACK FOOTER //
// ./src/utils/gaUtils.ts